import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element;
    }

    disconnect() {
        super.disconnect();
    }

    selectLid({ params: { query }}) {
        if( this.form.selectfunctie.selectedIndex < 1 ) {
            alert('Gelieve eerst een functie te kiezen');
            return
        }
        if( this.form.sinds.value == "" ) {
            alert('Gelieve de datum in te vullen');
            return
        }
        var w = window.open("/leden/select.html?"+query,"lidselect","left=600,screenX=600,top=80,screenY=100,menubar=no,toolbar=no,width=400,height=600,resizable=yes",false);
        w.focus();
        // remember which window we created
        window.lid_popup = w;
    }

    lidSelected({ detail }) {
        this.log('lidSelected', [detail]);

        var listbox = this.form.selectfunctie;
        var sinds = this.form.sinds.value;

        if( listbox.selectedIndex > 0 ) {
            let funid = listbox.options[listbox.selectedIndex].value;
            let funnaam = listbox.options[listbox.selectedIndex].text;

            let dt = this.form.querySelector("#dynatable_bestuur");
            dt.dynatable.addItem( { bslid_sinds: sinds, bslid_lid_id: detail.id, bslid_lid_naam: detail.voornaam +" "+detail.naam, bslid_functie_id: funid, bslid_functie_naam : funnaam } );

            if( funid != 5 ) {
                // give focus back to popup or close it
                window.lid_popup.close();
            }
        } else {
            alert('Gelieve eerst een functie te kiezen');
        }
    }

}
